import React from 'react';
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white relative">
      {/* Background Effects */}
      <div className="fixed inset-0 green-gradient opacity-50"></div>
      <div className="fixed top-20 left-1/4 w-[500px] h-[500px] bg-[#00FF9D]/5 rounded-full blur-[100px]"></div>
      <div className="fixed bottom-20 right-1/4 w-[500px] h-[500px] bg-[#00FF9D]/5 rounded-full blur-[100px]"></div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-[#00FF9D] hover:text-[#00FF9D]/80 mb-8">
          <span>← Retour</span>
        </Link>
        
        <h1 className="text-4xl font-bold mb-8 mono text-center">POLITIQUE DE CONFIDENTIALITÉ DE TARSS</h1>
        
        <div className="prose prose-invert max-w-none">
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">INTRODUCTION</h2>
            <p className="text-gray-400">
              Chez Tarss, nous accordons une importance primordiale à la protection de vos données personnelles. 
              Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos 
              informations lors de l'utilisation de notre extension Chrome.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">COLLECTE DES DONNÉES</h2>
            
            <h3 className="text-xl font-bold mb-3 text-white">2.1. Données collectées automatiquement</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>Données de navigation liées à l'utilisation de l'extension</li>
              <li>Historique des interactions avec l'extension</li>
              <li>Informations techniques (type de navigateur, version)</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">2.2. Données LinkedIn collectées</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>Publications publiques du feed LinkedIn</li>
              <li>Offres de missions publiées publiquement</li>
              <li>Profils professionnels publics</li>
              <li>Statuts de disponibilité publics</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">2.3. Données fournies volontairement</h3>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Informations de profil utilisateur</li>
              <li>Préférences de recherche</li>
              <li>Critères de matching</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">UTILISATION DES DONNÉES</h2>
            <p className="text-gray-400 mb-4">Nous utilisons vos données pour :</p>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Fournir les services de l'extension</li>
              <li>Améliorer les fonctionnalités de matching</li>
              <li>Créer des statistiques anonymisées</li>
              <li>Optimiser l'expérience utilisateur</li>
              <li>Envoyer des notifications pertinentes</li>
              <li>Maintenir la sécurité de nos services</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">PARTAGE DES DONNÉES</h2>
            
            <h3 className="text-xl font-bold mb-3 text-white">4.1. Au sein de la communauté Tarss</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>Partage des opportunités professionnelles</li>
              <li>Partage des profils publics</li>
              <li>Statistiques agrégées anonymes</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">4.2. Avec des tiers</h3>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Nous ne vendons pas vos données</li>
              <li>Nous ne partageons pas vos données avec des annonceurs</li>
              <li>Accès limité pour nos prestataires techniques (hébergement, maintenance)</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">STOCKAGE ET SÉCURITÉ</h2>
            
            <h3 className="text-xl font-bold mb-3 text-white">5.1. Lieu de stockage</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>Les données sont stockées dans l'Union Européenne</li>
              <li>Nous utilisons des serveurs sécurisés</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">5.2. Durée de conservation</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>Données de navigation : 12 mois</li>
              <li>Données de profil : durée d'utilisation du service</li>
              <li>Données de matching : 6 mois</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">5.3. Mesures de sécurité</h3>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Chiffrement des données</li>
              <li>Accès restreint aux serveurs</li>
              <li>Protocoles de sécurité standards</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">VOS DROITS</h2>
            <p className="text-gray-400 mb-4">Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement</li>
              <li>Droit à la portabilité</li>
              <li>Droit d'opposition</li>
              <li>Droit à la limitation du traitement</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">COOKIES ET TRACEURS</h2>
            
            <h3 className="text-xl font-bold mb-3 text-white">7.1. Cookies essentiels</h3>
            <ul className="list-disc pl-6 text-gray-400 mb-6">
              <li>Authentification</li>
              <li>Préférences utilisateur</li>
              <li>Sécurité</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-white">7.2. Cookies analytiques</h3>
            <ul className="list-disc pl-6 text-gray-400">
              <li>Mesure d'audience</li>
              <li>Amélioration des performances</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">PROTECTION DES MINEURS</h2>
            <p className="text-gray-400">
              L'extension Tarss n'est pas destinée aux personnes de moins de 18 ans.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">MODIFICATIONS DE LA POLITIQUE</h2>
            <p className="text-gray-400">
              Nous nous réservons le droit de modifier cette politique. Les utilisateurs seront informés des 
              changements importants.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4 text-[#00FF9D]">AUTORITÉS DE CONTRÔLE</h2>
            <p className="text-gray-400">
              Vous pouvez contacter la CNIL (Commission Nationale de l'Informatique et des Libertés) pour 
              toute réclamation.
            </p>
          </section>

          <div className="text-gray-400 text-sm mt-16">
            <p>Dernière mise à jour : 30/01/2025</p>
            <p>Par l'utilisation de Tarss, vous acceptez cette politique de confidentialité.</p>
          </div>
        </div>
      </div>
    </div>
  );
} 